import { render, staticRenderFns } from "./ConversationMessageCard.vue?vue&type=template&id=cb01c23a&scoped=true&"
import script from "./ConversationMessageCard.vue?vue&type=script&lang=js&"
export * from "./ConversationMessageCard.vue?vue&type=script&lang=js&"
import style0 from "./ConversationMessageCard.vue?vue&type=style&index=0&id=cb01c23a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb01c23a",
  null
  
)

export default component.exports